import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=bccc7164&scoped=true"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=bccc7164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccc7164",
  null
  
)

export default component.exports